import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class DateConverterService {

  constructor() { }

  public converterFormatUI(fecha) {
    const dateString = fecha;
    if (dateString != null) {
      const date = new Date(dateString);
      return date.toLocaleDateString('es-US');
    }
    return '';
  }

  public converterFormatAPI(fecha) {
    const dateString = fecha;
    if (dateString != null) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US');
    }
    return '';
  }

  public converterFormatDateTime(fecha) {
    if (fecha) {
      const date = fecha;
      const formattedDate = date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
      });
      return formattedDate.replace(/,/g, '');
    }
    return '';
  }
}
